module.exports = __webpack_public_path__ + "static/img/banner.2bfed1a8.png";